import { ManualStudentRegisterEntriesModel } from 'store/childRegister';

export const emptyManualStudentRegisterEntry = (): ManualStudentRegisterEntriesModel => {
  return {
    unitId: null,
    date: null,
    level: null,
  };
};
